'use client';
import './style.sass';

import React from 'react';

import {
    listConstructor,
    listFrontend,
    listInstruments,
    listInstrumentsTable,
    listNextjs,
    listPath,
    listStability,
    listStages,
    listStagesAudit,
    listStagesAuditFooter,
    listTitle,
} from './constants';
import FullWrapper from '../../cases/reusable-components/layouts-components__common-cases/full-wrapper';
import NextProject from '../../cases/reusable-components/layouts-components__common-cases/next-project';
import Bitrix from '../../cases/reusable-components/new-pochtabank__components/bitrix';
import Constructor from '../../cases/reusable-components/new-pochtabank__components/constructor';
import Design from '../../cases/reusable-components/new-pochtabank__components/design';
import Documentations from '../../cases/reusable-components/new-pochtabank__components/documentations';
import Frontend from '../../cases/reusable-components/new-pochtabank__components/frontend';
import Instruments from '../../cases/reusable-components/new-pochtabank__components/instruments';
import LayoutPage from '../../cases/reusable-components/new-pochtabank__components/layout-page';
import Nextjs from '../../cases/reusable-components/new-pochtabank__components/nextjs';
import Review from '../../cases/reusable-components/new-pochtabank__components/review';
import Stability from '../../cases/reusable-components/new-pochtabank__components/stability';
import Target from '../../cases/reusable-components/new-pochtabank__components/target';
import Team from '../../cases/reusable-components/new-pochtabank__components/team';
import TeamCustomer from '../../cases/reusable-components/new-pochtabank__components/team-customer';
import Testing from '../../cases/reusable-components/new-pochtabank__components/testing';
import ScrollAnimation from '../../../../../core/ScrollAnimation';
import OfferButton from '../../../../../shared/sections/OfferButton';
import TitleCase from '../../case-components/title-case';

const nextProjectdevRec = {
    nextProjectTitle:
        'Разработка интерактивной highload-платформы для Международного киберфестиваля Rukami',
    nextProjectImg: '/images/png/rukami.png',
    nextProjectLink: '/cases/development/rukami',
    nextProjectLinkTitle: 'Фонд поддержки проектов Национальной технологической инициативы',
    nextProjectText: 'Оперативно перевели активности фестиваля в&nbsp;онлайн',
};

const Pochtabank = () => {
    return (
        <section>
            <TitleCase
                img="/images/pic/new-pochtabank/pochta1920 1.jpg"
                listPath={listPath}
                listTitle={listTitle}
                caseName="pochtabank"
            />
            <Target />
            <LayoutPage
                listStages={listStages}
                listStagesAudit={listStagesAudit}
                listStagesAuditFooter={listStagesAuditFooter}
            />
            <Frontend listFrontend={listFrontend} />
            <Nextjs listNextjs={listNextjs} />
            <Instruments
                listInstruments={listInstruments}
                listInstrumentsTable={listInstrumentsTable}
            />
            <Design />
            <Constructor listConstructor={listConstructor} />
            <Bitrix />
            <Stability listStability={listStability} />
            <Testing />
            <Documentations />
            <Team />
            <TeamCustomer />
            <Review />
            <ScrollAnimation animateIn="zoomIn" offset={50} animateOnce={true} duration={1}>
                <FullWrapper>
                    <OfferButton linkText="Нанять команду" />
                </FullWrapper>
            </ScrollAnimation>

            <NextProject NextProject={nextProjectdevRec} />
        </section>
    );
};

export default Pochtabank;
